import { storeDate, type IsoDate } from "@estelle/domain";

import { reportingNow } from "@/lib/reportClock";

/**
 * The period a GST screen opens on: the financial year to date, from 1 April
 * to today in the store's time zone (#642).
 *
 * One place, so HSN Summary and Exports cannot drift apart again. Both used to
 * hard-code 1 Apr – 9 Sep 2026, the fixture clock's day, which on nonprod left
 * every invoice after 9 September out of the default view. `now` is the
 * reporting clock: the fixture's instant without an API, the real one with.
 */
export function gstDefaultPeriod(now: number = reportingNow()): {
  from: IsoDate;
  to: IsoDate;
} {
  const to = storeDate(now);
  const year = Number(to.slice(0, 4));
  const month = Number(to.slice(5, 7));
  // India's financial year starts on 1 April.
  const startYear = month >= 4 ? year : year - 1;
  return { from: `${String(startYear)}-04-01`, to };
}
